import { useState, useEffect } from "react";
import { faHeart as faHeartO } from "@fortawesome/free-regular-svg-icons";
import { faHeart, faCartShopping, faHardDrive, faMicrochip, faCamera, faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getWishListItems, loadCartItems } from "../../_helpers/cart.methods";
import { IconList } from "../../_helpers/detail-icons";


export const GradeCard = ({ data }) => {



    return (
        <div className="properties-list grade-card">
            {data?.properties?.map((prop, k) => (
                <div className="prop-list-row" key={k}>
                    <div className="prop-data-box">
                        <span className="prop-title">{Object.keys(prop)[0]}</span>
                        <span className="prop-data">{Object.values(prop)[0]}</span>
                    </div>
                </div>
            ))}
        </div>
    )
}